$(function() {
    $(document).on('click', '.js-evpt5__content--radio input[type=checkbox]', function(e) {
        $(e.target)
            .parents('.evpt5__content')
            .find('input[type=checkbox]')
            .not(this)
            .prop('checked', false);
    });
});
